<template>
  <div v-if="selectedDesign">
    <RevIllustration
      :alt="
        i18n(translations.selectedDesign, { designType: selectedDesign.type })
      "
      class="rounded-md overflow-hidden"
      :height="498"
      :src="selectedDesign.assetUrl"
      :width="498"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './SelectedDesign.translations'

const i18n = useI18n()
type DesignPicker =
  ApiSpecs['/api/gift-cards/v1/product-page/giftcard']['GET']['response']['designPickers'][number]

const props = defineProps<{
  designPickers: DesignPicker[]
  modelValue: string
}>()

const selectedDesign = computed(() => {
  return props.designPickers.find(
    (designPicker) => designPicker.id === props.modelValue,
  )
})
</script>
